import { json } from "@sveltejs/kit";
import { readFile } from "fs/promises";
import { join } from "path";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
const GET = async () => {
  try {
    const packageJsonPath = join(WORKSPACE_DIR, "package.json");
    const packageJson = await readFile(packageJsonPath, "utf-8");
    const pkg = JSON.parse(packageJson);
    return json(pkg.scripts || {});
  } catch (error) {
    console.error("Failed to read npm scripts:", error);
    return json({});
  }
};
export {
  GET
};
